export function loadScript(id, src, callback = null, asyncValue = false) {
  return new Promise((resolve, reject) => {
    let result = false
    const script = document.createElement('script')
    script.async = asyncValue
    script.id = id
    script.type = 'text/javascript'
    script.src = src
    script.onload = script.onreadystatechange = function() {
      if (!result && (!this.readyState || this.readyState === 'complete')) {
        result = true
        if (typeof callback === 'function') {
          callback()
        }
        resolve()
      }
    }
    if (!document.getElementById(id)) {
      document.getElementsByTagName('head')[0].appendChild(script)
    } else {
      if (typeof callback === 'function') {
        callback()
      }
      resolve()
    }
  })
}

export function isDeviceChanged() {
  if (typeof window === 'undefined') return {}
  const isMobile = window.matchMedia('screen and (max-width:479px)')
  const isTablet = window.matchMedia('screen and (max-width:959px)')
  const isDesktop = !isMobile.matches && !isTablet.matches

  return {
    isMobile: isMobile.matches,
    isTablet: isTablet.matches,
    isDesktop
  }
}

export const isMobile = isDeviceChanged().isMobile
export const isTablet = isDeviceChanged().isTablet
export const isDesktop = isDeviceChanged().isDesktop


// WEBPACK FOOTER //
// ./src/utils/common.js